<template>
  <div>
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Наименование типа помещения"
          :required="true"
          placeholder="Введите наименование типа помещения"
          :value="formData.placement_type_name || ''"
          @change_input="value => onChange('placement_type_name', value)"
        />
      </div>
      
      <div class="form__item">
        <CustomInput
          label="Код типа помещения"
          :required="true"
          placeholder="Например: RESIDENCE"
          :value="formData.placement_type_code || ''"
          @change_input="value => onChange('placement_type_code', value)"
          hint="Примеры: RESIDENCE, METERING_ROOM"
        />
      </div>
      
      <CustomModalFooter
        :btn-loading="loading"
        :on-submit="onSubmit"
        submit-btn-text="Создать тип помещения"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CustomInput from '@/components/form/CustomInput'
import CustomModalFooter from '@/components/modal/modals/modal-footer'

import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import { createPlacementType } from '@/views/PackageEntry/services'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  closeModal: {
    type: Function,
    default: () => {}
  }
})

const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()

const loading = ref(false)
const formData = ref({
  placement_type_id: null,
  placement_type_name: '',
  placement_type_code: ''
})

const onChange = (field, value) => {
  formData.value[field] = value
}

const closeModal = () => {
  props.closeModal()
}

const onSubmit = async () => {
  if (!formData.value.placement_type_name || !formData.value.placement_type_code) {
    showErrorSnackbar('Заполните все обязательные поля')
    return
  }
  
  loading.value = true
  
  const res = await createPlacementType(formData.value)
  if (!res) {
    loading.value = false
    return
  }
  showSucceedSnackbar('Тип помещения успешно создан')
  
  if (props.data?.onClose) {
    props.data.onClose(res)
  }
  
  closeModal()
  loading.value = false
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__item {
    display: flex;
    flex-direction: column;
  }
}
</style>